import { Command } from '@/app/common/base/command'

export class CancelAppointmentCommand extends Command {
    public async run(id: string) {
        await this.client.post(`/api/products/appointments/${id}/cancel`)
        await this.store.dispatch('appointment/deleteAppointment', id)
    }
}
